import script from "./CustomerSupportView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSupportView.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSupportView.vue?vue&type=style&index=0&id=0b798e25&lang=css"

const __exports__ = script;

export default __exports__